import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default class CarouselCta {
    constructor() {
        this.carouselCtas = document.querySelectorAll('.fd-block-carousel-cta');

        this.init();
    }

    init() {
        if(this.carouselCtas.length) {
            this.carouselCtas.forEach((elt, index) => {
                const carouselCta = new Swiper('.fd-carousel-cta', {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    spaceBetween: 20,
                    grabCursor: true,
                    pagination: {
                        el: '.fd-block-carousel-cta .swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.fd-block-carousel-cta .swiper-next',
                        prevEl: '.fd-block-carousel-cta .swiper-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                })
            })
        }
    }
}